import { SelectOption } from "../form/FormTypes";

export const convertEnumsToOptions = (valueEnums: any, textEnums: any): SelectOption[] => {
    return Object.keys(valueEnums).map((mode) => {
        return { value: valueEnums[mode], text: textEnums[mode] };
    });
};
